import { render, staticRenderFns } from "./BuyList.vue?vue&type=template&id=7a2067bc&"
import script from "./BuyList.vue?vue&type=script&lang=js&"
export * from "./BuyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports